import { z } from 'zod';

export enum VersionedArtifactTypeGroup {
    PROJECT_VERSION = 'PROJECT_VERSION',
}

export const VersionedArtifactTypeGroupSchema = z.enum(VersionedArtifactTypeGroup);
